import { network } from 'services/network';

export const updateProject = (params) => {
    return network.post('api/bo/management/updateProject', params).then((response) => {
        return response.data;
    });
};
